import { render, staticRenderFns } from "./customsMode.vue?vue&type=template&id=851e73a0&"
import script from "./customsMode.vue?vue&type=script&lang=js&"
export * from "./customsMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('851e73a0')) {
      api.createRecord('851e73a0', component.options)
    } else {
      api.reload('851e73a0', component.options)
    }
    module.hot.accept("./customsMode.vue?vue&type=template&id=851e73a0&", function () {
      api.rerender('851e73a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/customsMode.vue"
export default component.exports